<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import FeeModal from '@/components/modals/fee-modal.vue';
import { cloneDeep } from 'lodash';
export default {
    page: {
        title: "Fees",
    },
    components: {
        Layout,
        PageHeader,
        LoadingTemplate,
        FeeModal
    },
    data() {
        return {
            title: "Fees",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Fees",
                    active: true,
                },
            ],
            loading: false,
            fees: [],
            accounts: [],
            currentPage: 1,
            perPage: 18,
            pageOptions: [18, 42, 90, 120],
            filter: '',
            modalTitle: ''
        }
    },
    created() {
        this.changeCampus(this.$store.state.data.selectedCampus.id);
        this.getAccounts();
    },
    computed: {
        filtered() {
            let data = this.fees;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            data = data.slice(total - this.perPage, total);
            return data;
        },
        rows() {
            if (this.filter.trim() != "" && this.filter) {
                let data = this.fees;
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
                return data.length;
            }
            return this.fees.length;
        },
    },
    methods: {
        async changeCampus(id) {
            this.loading = true;
            await this.getFees(id);
            this.loading = false;
        },
        async getFees(id) {
            await this.$store
                .dispatch("fee/getFeesByCampus", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fees = res.data;
                })
                .catch((error) => {
                    this.showToast("Cannot fetch fees. Please contact your administrator", "error");
                });
        },
        async getAccounts() {
            await this.$store
                .dispatch("accounts/getAllAccounts")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.accounts = res.data;
                })
                .catch(() => {
                    this.showToast("Cannot fetch accounts. Please contact your administrator", "error");
                });
        },
        addNewFee() {
            this.modalTitle = 'Add New Fee';
            this.$refs.feeModal.updateData({
                id: 0,
                name: null,
                shortName: null,
                defaultAmount: '',
                accountId: null,
                visible: true,
                active: true,
                account: null
            });
            this.$bvModal.show('fee-modal');
        },
        updateItem(row) {
            this.modalTitle = 'Add New Fee';
            let data = cloneDeep(row);
            data.defaultAmount = row.defaultAmount.toString();
            this.$refs.feeModal.updateData(data);
            this.$bvModal.show('fee-modal');
        },
        async onCreateFee(modalData) {
            let data = cloneDeep(modalData);
            data.defaultAmount = modalData.defaultAmount ? this.getExactAmt(modalData.defaultAmount) : 0;
            data.campusId = this.$store.state.data.selectedCampus.id;
            if (modalData.id > 0) {
                await this.$store
                    .dispatch("fee/updateFee", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.fees.findIndex(fee => fee.id == modalData.id);
                        this.$set(this.fees, index, res.data);
                        this.$bvModal.hide('fee-modal')
                        this.showToast("Fee successfully updated", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong - Cannot update fee", "error");
                    });
            } else {
                await this.$store
                    .dispatch("fee/createNewFee", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.fees.unshift(res.data);
                        this.$bvModal.hide('fee-modal')
                        this.showToast("New fee successfully saved", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong - Cannot save new fee", "error");
                    });
            }
        },
        deleteItem(item) {
            this.$swal({
                title: "Are you sure?",
                text: "You can add this fee again if you want to.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                confirmButtonText: "Yes, delete it",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$store
                        .dispatch("fee/deleteFee", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let ind = this.fees.findIndex(fee => fee.id == item.id);
                            this.fees.splice(ind, 1);
                            this.showToast("Fee successfully deleted", "success");
                        })
                        .catch((error) => {
                            this.showToast("Cannot delete template. Please contact your administrator", "error");
                        });
                }
            });
        }
    }
}
</script>
<template>
    <Layout @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <div class="d-flex justify-content-between">
            <div id="tickets-table_filter" class="dataTables_filter">
                <label class="d-inline-flex align-items-between">
                    <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search Fee..."
                        class="form-control me-1" style="width:250px;" @input="currentPage = 1"></b-form-input>
                    <b-select class="form-select" v-model="perPage" :options="pageOptions"
                        style="width:80px;"></b-select>
                </label>
            </div>
            <div>
                <button class="btn btn-info" @click="addNewFee"><i class="bx bx-plus"></i> Add New Fee</button>
            </div>
        </div>
        <template v-if="loading">
            <div class="my-5 py-5">
                <LoadingTemplate />
            </div>
        </template>
        <template v-if="!loading && !fees.length">
            <div class="my-5 py-5 text-center">
                <h4 class="mb-0">No data found.</h4>
            </div>
        </template>
        <template v-if="!loading && !filtered.length && fees.length">
            <div class="my-5 py-5 text-center">
                <h4 class="mb-0">Search not found.</h4>
            </div>
        </template>
        <div class="row mt-3">
            <template v-for="(x, xInd) in filtered">
                <div class="col-md-4" :key="x.id">
                    <div class="card border shadow-none" :style="{ 'zIndex': (filtered.length - xInd) + 100 }">
                        <div class="card-header ps-3 pe-2">
                            <div class="d-flex justify-content-between align-items-start">
                                <div class="w-100">
                                    <p class="mb-0 font-size-16 text-white">{{ x.name }}</p>
                                    <small class="d-block">({{ x.shortName }})</small>
                                    <small>{{ x.account.accountName }}</small>
                                    <p class="mb-0">Default Amount: <span
                                            class="text-warning">{{ formatCurrency(x.defaultAmount) }}</span></p>
                                </div>
                                <div style="width:30px;" class="d-flex justify-content-end">
                                    <b-dropdown id="dropdown-dropleft" right variant="link"
                                        toggle-class="text-decoration-none" menu-class="dropdown-menu-end" no-caret>
                                        <template #button-content>
                                            <i class="fas fa-ellipsis-v"></i>
                                        </template>
                                        <b-dropdown-item @click="updateItem(x)" variant="secondary">
                                            <i class="mdi mdi-update font-size-18 me-1"></i>Edit
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="deleteItem(x)" variant="danger">
                                            <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="row">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end" v-if="fees.length && filtered.length">
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <FeeModal ref="feeModal" :modalTitle="modalTitle" :accounts="accounts" @submit="onCreateFee" />
    </Layout>
</template>